import { isEmpty } from 'lodash-es';

export function isObject(maybeObj: any) {
  return typeof maybeObj === 'object' && !Array.isArray(maybeObj) && maybeObj !== null;
}

export function isEmptyOrEmptyObject(obj: any) {
  if (!isObject(obj)) {
    return isEmpty(obj);
  }

  return Object.keys(obj).length === 0;
}
